export const CART_INITIALISE = 'WS_CART_INITIALISE'
export const IS_CART_INITIALISED = 'cart/IS_CART_INITIALISED'
export const CART_EMPTIED = 'WS_CART_EMPTIED'
export const CART_FETCH = 'WS_CART_FETCH'
export const CART_REVIEWED = 'WS_CART_REVIEWED'
export const CART_COMPLETED = 'WS_CART_COMPLETED'
export const PAYMENT_PROCESSED = 'WS_PAYMENT_PROCESSED'
export const CART_FETCH_ERROR = 'WS_CART_FETCH_ERROR'
export const PROGRAM_TYPE_FETCH_ERROR = 'WS_PROGRAM_TYPE_FETCH_ERROR'
export const SET_ENTITLEMENT = 'SET_ENTITLEMENT'
export const SET_ACTIVE_CART_TAB = 'cart/SET_ACTIVE_CART_TAB'
export const SET_TAXES = 'cart/SET_TAXES'
export const TAX_COMPUTATION_ERROR = 'cart/TAX_COMPUTATION_ERROR'
export const TAX_SERVICE_UNAVAILABLE_ERROR = 'cart/TAX_SERVICE_UNAVAILABLE_ERROR'
export const CREATE_SIGNATURE_ERROR = 'cart/CREATE_SIGNATURE_ERROR'
export const PAYMENT_ERROR = 'cart/PAYMENT_ERROR'
export const CYBERSOURCE_ERROR = 'cart/CYBERSOURCE_ERROR'
export const CART_PROCESSING = 'cart/CART_PROCESSING'
export const SET_ADDRESS_VALIDATED = 'cart/SET_ADDRESS_VALIDATED'
export const SET_ADDRESS_LIST = 'cart/SET_ADDRESS_LIST'
export const SET_ADDRESS_DETAILS = 'cart/SET_ADDRESS_DETAILS'
export const SET_CART_DOCKED = 'cart/SET_CART_DOCKED'
export const CYBERSOURCE_VALIDATED = 'cart/CYBERSOURCE_VALIDATED'



// WEBPACK FOOTER //
// ./src/containers/Cart/constants.js